<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Hủy yêu cầu điều xe
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Hủy yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import hanhchinhService from "../../../services/hanhchinhService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import CustomDialog from "../../common/custom-dialog";
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCaseDieuXeService from "../../../services/hcCaseDieuXeService";

export default {
  name: "hc-dieuxe-huy-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "id"],
  components: {
    CustomDialog
  },
  data() {
    return {
      form: {
        note: null
      },
      rules: {
        note: null
      },
      hcCaseDieuXe: null
    };
  },

  async created() {
    await this.loadHcCaseDieuXe();
    this.initValidationRules();
  },

  methods: {
    loadHcCaseDieuXe() {
      return hcCaseDieuXeService
        .findById(this.id)
        .then(response => (this.hcCaseDieuXe = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      this.rules.note = [defaultRequiredConstrains];
    },

    convertToSubmitForm() {
      return {
        action: constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.HUY_YEU_CAU,
        caseMasterId: this.hcCaseDieuXe.hcCaseMasterId,
        note: this.form.note
      };
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({
              message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
              type: "error"
            });
          } else {
            resolve();
          }
        });
      });
    },

    submit() {
      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hanhchinhService
            .cancelCar(submitForm)
            .then(response => response.data);
        })
        .then(hcCaseCommands => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcDieuXe.cancelSuccess"
            }),
            type: "success"
          });
          this.$emit("cancelSuccess", {result: hcCaseCommands});
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-huy-dialog.vue